import React from "react";
import { Box, Button } from "@mui/material";
import AxionControls from "../../../components/controls/AxionControls";
import { FormattedMessage } from "react-intl";
import messages from "./messages";

export default function AddEditUserDialog(props) {

    return (
        <Box 
            sx={{
                p:1,
                m:1
            }}>
                <Box sx={{width: 400}}>
                    { props.user.id === null ? (
                        <AxionControls.AxionTextBox 
                            name="username"
                            label={<FormattedMessage {...messages.usernameColumnLabel} />}
                            value={props.user.username}
                            onChange={props.onChange}
                        />
                    ) : (
                        <AxionControls.AxionTextBoxReadOnly 
                            name="username"
                            label={<FormattedMessage {...messages.usernameColumnLabel} />}
                            value={props.user.username}
                            onChange={props.onChange}
                        />
                    )}
                </Box>
                <Box sx={{width: 400}}>
                    <AxionControls.AxionTextBox 
                        name="name"
                        label={<FormattedMessage {...messages.nameColumnLabel} />}
                        value={props.user.name}
                        onChange={props.onChange}
                    />
                </Box>
                <Box sx={{width: 400, mt:2}}>
                    <AxionControls.AxionSelect
                        name="roles"
                        label={<FormattedMessage {...messages.rolesColumnLabel} />}
                        value={props.user.roles}
                        onChange={props.onRolesChange}
                        options={props.roles.map(role => ({ id: role.id, title: role.roleName })) || []}
                        multiple={true}
                        showNoneOption={false}
                    />
                </Box>
               <Box>
                    <Button 
                        variant="contained" 
                        sx={{
                            marginTop: 2,
                            }}
                        onClick={props.handleSave}>
                        <FormattedMessage {...messages.save} />
                    </Button>
                </Box>
        </Box>
    );
}